import Container from "./layouts/Container";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";

export default function Menu({ setSearchOpen }) {
  const navigate = useNavigate();
  const pageCaller = (link, sub) => {
    const session_name = "called_" + link;
    const session_item = sessionStorage.getItem(session_name);
    let link_ = "/"+link;
    const params = [];
    if(sub) params.push(`sub=${sub}`);
    if (session_item) {
      //5分立ったらリセット
      if (new Date().getTime() - session_item > 60000 * 5) {
        sessionStorage.removeItem(session_name);
      }
      navigate(link_+"?"+params.join("&"));
    } else {
      sessionStorage.setItem(session_name, new Date().getTime());
      params.push(`page=${link}`);
      window.location.href = "/"+link + "?" + params.join("&");
    }
  };

  return (
    <Container>
      <ul>
        <li>
          <button onClick={() => pageCaller("news")}>
            <img
              alt="news"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_news_w.png"
            />
          </button>
        </li>
        <li>
          <button onClick={() => pageCaller("eventlist")}>
            <img
              alt="event"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_event_w.png"
            />
          </button>
        </li>
        <li>
          <Link to="/kpop">
            <img
              alt="kpop"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_kpop_w.png"
            />
          </Link>
        </li>
        <li>
          <Link to="/blog">
            <img
              alt="blog"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_vinyl_w.png"
            />
          </Link>
        </li>
        <li>
          <Link to="/floorguide">
            <img
              alt="floor guide"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_guide_w.png"
            />
          </Link>
        </li>
        <li>
          <Link to="/access">
            <img
              alt="access"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_access_w.png"
            />
          </Link>
        </li>
        <li>
          <Link to="/towerrecordstv">
            <img
              alt="tv"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_tv_w.png"
            />
          </Link>
        </li>
        <li>
          <button onClick={() => pageCaller("tousen")}>
            <img
              alt="tousen"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_tousen_w.png"
            />
          </button>
        </li>
        {window.run_mode !== 1 && (
          <li>
            <SearchIcon
              style={{ color: "#ffffff" }}
              onClick={() => setSearchOpen(true)}
            />
          </li>
        )}
      </ul>
      <ul>
        <li>
          <button onClick={() => pageCaller("storenews", "MINATOMIRAI BRANCH")}>
            <img
              alt="tousen"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_minatomirai_w.png"
            />
          </button>
        </li>
        <li>
          <button onClick={() => pageCaller("storenews", "SUNSHINECITY ALPA BRANCH")}>
            <img
              alt="tousen"
              className="icon"
              src="https://towershibuya.jp/assets/images/menu/menu_ikebukuro_w.png"
            />
          </button>
        </li>
      </ul>
    </Container>
  );
}
